"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What items are accepted for pickup?",
  answer: "We accept clothing, shoes, coats, and accessories that are in good, wearable condition. To ensure your donations can be used by our local charity partners, please ensure items are clean and free of stains, mold, or significant damage."
}, {
  question: "Do I need to be home when you arrive?",
  answer: "No, our service is completely contactless. Simply place your items in bags or boxes on your front porch by 8:00 AM on your scheduled pickup day. Our team will collect them and leave a confirmation tag if requested."
}, {
  question: "Is there any cost for the pickup service?",
  answer: "Our service is 100% free for residents within our Ottawa service areas. As a community-focused nonprofit, our goal is to make donating as easy as possible to reduce textile waste and support local neighbors."
}, {
  question: "What happens to the clothing I donate?",
  answer: "Once collected, items are brought to our local facility where they are sorted by hand. We partner with various Ottawa-based charities and community centers to ensure your donations reach those who need them most."
}, {
  question: "How do I book a pickup for my area?",
  answer: "You can schedule your pickup through our online booking form. Simply provide your address and contact details, then select the designated pickup day for your neighborhood (Kanata on Mondays, Nepean on Tuesdays, or Downtown on Wednesdays)."
}];
export default function CommonInquiries() {
  return <section data-section-id="3584" id="everything-you-need-to-know" className="bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 max-w-[800px]">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-default font-bold tracking-tight text-foreground sm:text-4xl mb-4">
            Everything You Need to Know
          </h2>
          <p className="text-muted-foreground text-lg font-sans">
            Common questions about our free clothing pickup service in Ottawa.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0" data-index={i}>
              <AccordionTrigger className="group py-6 hover:no-underline [&>svg:last-child]:hidden">
                <span className="text-lg font-default font-semibold text-foreground text-left pr-4">
                  {faq.question}
                </span>
                <span className="shrink-0 flex items-center justify-center size-6 rounded-full border border-transparent group-hover:bg-accent/50 transition-colors">
                  <Plus className="size-5 text-primary stroke-[1.5] transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground font-sans pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}